import React from 'react';
import { UserProvider, useUser } from 'util/UserContext';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Feed from 'components/Entities/Feed'
import AddIssue from 'components/Issues/AddIssue'
import IssueProfile from 'components/Issues/IssueProfile'
import UserProfile from 'components/User/UserProfile'
import SolutionProfile from 'components/Solutions/SolutionProfile'
import ImpactProfile from 'components/Impacts/ImpactProfile'
import InfluenceProfile from 'components/Influences/InfluenceProfile'
import AppBar from 'components/Navigation/AppBar'
import UserSettings from 'components/User/UserSettings'
import FeedbackProfile from 'components/Feedback/FeedbackProfile'
import AdminPortal from 'components/Admin/AdminPortal'
import PrivacyPolicy from './PrivacyPolicy'
import AuthModal from 'components/Auth/AuthModal'
import AuthLogin from 'components/Auth/AuthLogin'
import WelcomeModal from 'components/WelcomeModal';
import UsernameModal from 'components/User/UsernameModal';
import UserOnboardModal from 'components/User/UserOnboardModal';
import MeetingProfile from 'components/Meetings/MeetingProfile';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import {
    Experimental_CssVarsProvider as MaterialCssVarsProvider,
    THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles'
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles'
import CssBaseline from '@mui/material/CssBaseline'
import joyTheme from 'ui/joyTheme'
import materialTheme from 'ui/materialTheme'
import { ThemeProvider } from './context/ThemeContext';
//import AssessmentProfile from 'components/Assessments/AssessmentProfile';
import NotFoundPage from 'components/ResponsePages/404NotFoundPage';
import ServerErrorPage from 'components/ResponsePages/500ServerErrorPage';
import { Toaster } from 'ui/Sonner';
import PasswordResetPage from './components/Auth/PasswordResetPage';
import TeamProfile from 'components/Teams/TeamProfile';
import TeamsTabs from 'components/Teams/TeamsTabs';
import TeamSettings from 'components/Teams/TeamSettings'
import Community from 'components/Common/Community';
import { ScrollToTop } from 'util/navUtils';

const App = () => {
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);

    useEffect(() => {
        const hasSeenWelcome = Cookies.get('hasSeenWelcome');
        
        if (!hasSeenWelcome) {
            setShowWelcomeModal(true);
            Cookies.set('hasSeenWelcome', 'true', { expires: 365 });
        }
    }, []);

    const handleCloseWelcomeModal = () => {
        setShowWelcomeModal(false);
    };

    return (
        <UserProvider>
          <div className="min-h-screen bg-eoe-bg dark:!bg-eoe-dark-bg transition-colors duration-200 dark:text-gray-500">
            <Router>
              <ScrollToTop>
                <ThemeProvider>
                  <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
                    <JoyCssVarsProvider theme={joyTheme}>
                      <CssBaseline enableColorScheme />
                      <Toaster />
                      <div className="App h-full pt-14 xl:ml-[260px] transition-colors duration-200">
                        <AppBar />
                        <div>
                          <Routes>
                            <Route path="/" element={<Feed />} />
                            <Route path="/:entityType" element={<Feed />} />
                            <Route path="/:entityType/:sort" element={<Feed />} />
                            <Route path="/login" element={<AuthLogin />} />
                            <Route
                              path="/add-issue"
                              element={<AddIssue open={false} onClose={() => {}} />}
                            />
                            <Route path="/issue/:cname/" element={<IssueProfile />} />
                            <Route path="/issue/:cname/:tab" element={<IssueProfile />} />
                            <Route path="/issue/:cname/comments/:commentId" element={<IssueProfile />} />
                            <Route path="/settings/" element={<UserSettings />} />
                            <Route path="/settings/:tab" element={<UserSettings />} />
                            <Route path="/user" element={<UserProfile />} />
                            <Route path="/user/:username" element={<UserProfile />} />
                            <Route path="/user/:username/:tab" element={<UserProfile />} />
                            <Route path="/solution/:id" element={<SolutionProfile />} />
                            <Route path="/solution/:id/:tab" element={<SolutionProfile />} />
                            <Route
                              path="/solution/:id/comments/:commentId"
                              element={<SolutionProfile />}
                            />
                            <Route path="/impact/:id" element={<ImpactProfile />} />
                            <Route path="/impact/:id/:tab" element={<ImpactProfile />} />
                            <Route
                              path="/impact/:id/comments/:commentId"
                              element={<ImpactProfile />}
                            />
                            <Route path="/feedback/:id" element={<FeedbackProfile />} />
                            <Route path="/feedback/:id/:tab" element={<FeedbackProfile />} />
                            <Route
                              path="/feedback/:id/comments/:commentId"
                              element={<FeedbackProfile />}
                            />
                            <Route path="/admin" element={<AdminPortal />} />
                            <Route path="/admin/:tab" element={<AdminPortal />} />
                            <Route
                              path="/policies/privacy-policy"
                              element={<PrivacyPolicy />}
                            />
                            <Route path="/influence/:id" element={<InfluenceProfile />} />
                            <Route path="/influence/:id/:tab" element={<InfluenceProfile />} />
                            <Route
                              path="/influence/:id/comments/:commentId"
                              element={<InfluenceProfile />}
                            />
                            <Route path="/communitea" element={<Community />} />
                            <Route path="/communitea/:tab" element={<Community />} />
                            <Route path="/communitea/parteas/:tab" element={<Community />} />
                            {/* New Team Routes */}
                            <Route path="/parteas" element={<TeamsTabs />} />
                            <Route path="/parteas/:tab" element={<TeamsTabs />} />
                            <Route path="/partea/:teamname" element={<TeamProfile />} />
                            <Route path="/partea/:teamname/:tab" element={<TeamProfile />} />
                            <Route path="/partea/:teamname/settings" element={<TeamSettings />} />
                            <Route path="/partea/:teamname/settings/:tab" element={<TeamSettings />} />
                            <Route path="/event/:id" element={<MeetingProfile />} />
                            <Route path="/event/:id/:tab" element={<MeetingProfile />} />
                            <Route path="/404" element={<NotFoundPage />} />
                            <Route path="/500" element={<ServerErrorPage />} />
                            <Route path="/password" element={<AuthModal passwordReset={true} show={true} onClose={() => {}} />} />
                            <Route path="/passwordrecovery" element={<PasswordResetPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                          </Routes>
                        </div>
                        <AuthModalWrapper />
                        <UsernameModalWrapper />
                        <UserOnboardModalWrapper />
                        <WelcomeModal 
                          open={showWelcomeModal} 
                          onClose={handleCloseWelcomeModal} 
                        />
                      </div>
                    </JoyCssVarsProvider>
                  </MaterialCssVarsProvider>
                </ThemeProvider>
              </ScrollToTop>
            </Router>
          </div>
        </UserProvider>
    )
}

const AuthModalWrapper = () => {
  const { showAuthModal, setShowAuthModal } = useUser();

  return (
    <>
      {showAuthModal && (
        <AuthModal show={showAuthModal} onClose={() => setShowAuthModal(false)} />
      )}
    </>
  );
};

const UsernameModalWrapper = () => {
  const { showUsernameModal, setShowUsernameModal } = useUser();

  return (
    <>
      {showUsernameModal && (
        <UsernameModal onClose={() => setShowUsernameModal(false)} userSignup={true} />
      )}
    </>
  );
};

const UserOnboardModalWrapper = () => {
  const { showUserOnboardModal, setShowUserOnboardModal } = useUser();
  return (
    <>
      {showUserOnboardModal && (
        <UserOnboardModal
          isOpen={showUserOnboardModal}
          onClose={() => setShowUserOnboardModal(false)}
        />
      )}
    </>
  );
};

export default App;
